export default __webpack_public_path__ + "static/media/list_event_none.616faa5a.png";